<template>
  <div class="scpPage">
    <div class="operation">
      <div>
      <i-button @click="getServiceInfo">
        <i class="iconfont icon-refresh"></i>
        刷新
      </i-button>
      <i-button @click="showLog = true" style="margin-left: 15px;" type="primary">
        查看日志
      </i-button>
    </div>
      <div style="display: flex;align-items: center;">
      <i-switch
          v-model="isOpen"
          @on-change="changeSwitch"
          size="small"
          style="margin: 8px 20px 0 0px"
        ></i-switch>
      <div class="status">
        {{
          result.serviceStatus == 10
            ? "启 用"
            : result.serviceStatus == 11
            ? "启 用 中"
            : result.serviceStatus == 21
            ? "禁 用 中"
            : "禁 用"
        }}
      </div>
    </div>
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>DICOM QR服务基本信息
      </div>
      <!-- <div style="display: flex;justify-content: space-between;">
        <div class="log" @click="showLog = true">查看日志</div><i-switch v-model="isOpen" @on-change="changeSwitch" size="small"
          style="margin: 8px 0 0 0;"></i-switch>
      </div> -->
    </div>
    <div class="des">
      <div class="serDes"><span class="secondTit">服务描述：</span>{{ result.description }}</div>
      <!-- <div><span class="secondTit">创建时间：</span>{{ result.createTime }}</div> -->
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>基础配置
      </div>
    </div>
    <div class="des">
      <Form :label-width="120" inline>
        <FormItem label="一轮休眠时长(秒)">
          <InputNumber :min="0" type="number" v-model="baseData.interval" clearable></InputNumber>
        </FormItem>
        <FormItem label="是否打印SQL">
          <Radio-group v-model="baseData.isPrintSql">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </Radio-group>
        </FormItem>
        <FormItem label="日志级别">
          <Select v-model="baseData.logLevel" style="width:200px">
            <Option v-for="item in LogsData" :value="item.key" :key="item.key">{{ item.value }}</Option>
          </Select>
        </FormItem>

      </Form>
      <Button class="ml-5 mr-5" type="primary" @click="SetQrBaseConfig">确定</Button>
      <Button @click="cancelEdit">重置</Button>
      <div>

      </div>
    </div>
    <div class="listenList">
      <div class="right">
        <div class="tit">
          <div class="line"></div>监听列表
        </div>
        <Table border highlight-row :columns="columnsOne" :data="localQRInfos"></Table>
      </div>
      <div class="left">
        <div class="tit">
          <div class="line"></div>编辑监听参数
        </div>
        <div class="contain">
          <Form :label-width="69">
            <FormItem label="默认IP">
              <Input placeholder="请输入" v-model="paramsListen.LoacalIP" clearable></Input>
            </FormItem>
            <FormItem label="监听端口">
              <Input placeholder="请输入" v-model="paramsListen.LocalPort" clearable></Input>
            </FormItem>
            <FormItem label="本地AE">
              <Input placeholder="请输入" v-model="paramsListen.LocalAE" clearable></Input>
            </FormItem>
          </Form>
        </div>
        <div class="btnGroup">
          <Button class="cancel" @click="clear('listen')">重置</Button>
          <Button type="primary" @click="addOrEidt('listen', 'save')">{{ btnName }}</Button>
        </div>
      </div>
      
    </div>
    <div class="listenList">
      <div class="right">
        <div class="tit">
          <div class="line"></div>DICOM QR 列表
        </div>
        <Table border highlight-row :columns="columns" :data="qRSCUInfos"></Table>
      </div>
      <div class="left">
        <div class="tit">
          <div class="line"></div>编辑DICOM QR 参数
        </div>
        <div class="contain">
          <Form :label-width="69">
            <FormItem label="节点IP">
              <Input placeholder="请输入" v-model="paramsAE.IP" clearable></Input>
            </FormItem>
            <FormItem label="节点AE">
              <Input placeholder="请输入" v-model="paramsAE.AE" clearable></Input>
            </FormItem>
            <FormItem label="节点方式">
              <Select v-model="paramsAE.RequestType" :label-in-value="true">
                <Option v-for="(item, index) in pointList" :value="item.name" :key="index">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="发送IP" v-if="paramsAE.RequestType === 'C-Move'">
              <Input placeholder="请输入" v-model="paramsAE.RemoteIP" clearable></Input>
            </FormItem>
            <FormItem label="发送端口" v-if="paramsAE.RequestType === 'C-Move'">
              <Input placeholder="请输入" v-model="paramsAE.RemotePort" clearable></Input>
            </FormItem>
            <FormItem label="服务AE" v-if="paramsAE.RequestType === 'C-Move'">
              <Input placeholder="请输入" v-model="paramsAE.RemoteAe" clearable></Input>
            </FormItem>
            <FormItem label="医院编码" v-if="paramsAE.RequestType === 'C-Move'">
              <Input placeholder="请输入" v-model="paramsAE.HospitalCode" clearable></Input>
            </FormItem>
          </Form>
        </div>
        <div class="btnGroup">
          <Button class="cancel" @click="clear('AE')">重置</Button>
          <Button type="primary" @click="addOrEidt('AE', 'save')">{{ btnAEname }}</Button>
        </div>
      </div>
    
    </div>
    <Modal v-model="showLog" title="DICOM QR服务日志" :footer-hide="true" :width="1000">
      <log v-if="showLog" @close="showLog = false" :from="'dicom'"></log>
    </Modal>
  </div>
</template>
<script>
import log from './log.vue';
export default {
  components: { log },
  data() {
    return {
      Status:null,
      timer:null,
      LogsData: [],
      oldBaseData: {},
      baseData: {},
      serviceSign: '',
      isOpen: false,
      showLog: false,
      result: {},
      paramsListen: {},
      paramsAE: {},
      columnsOne: [
        { title: "本机IP", key: "LoacalIP" },
        { title: "本机端口", key: "LocalPort" },
        { title: "本地AE", key: "LocalAE" },
        {
          title: "操作",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: '#3795C8',
                  },
                  on: {
                    click: () => {
                      this.addOrEidt('listen', 'edit', params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: '#3795C8',
                  },
                  on: {
                    click: () => {
                      this.delete('listen', params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      columns: [
        { title: "节点IP", key: "IP" },
        { title: "节点AE", key: "AE" },
        { title: "节点方式", key: "RequestType" },
        { title: "发送IP", key: "RemoteIP" },
        { title: "发送端口", key: "RemotePort" },
        { title: "服务AE", key: "RemoteAe" },
        { title: "医院编码", key: "HospitalCode" },
        {
          title: "操作",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: '#3795C8',
                  },
                  on: {
                    click: () => {
                      this.addOrEidt('AE', 'edit', params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: '#3795C8',
                  },
                  on: {
                    click: () => {
                      this.delete('AE', params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      btnName: '新增',
      btnAEname: '新增',
      status: 10,
      pointList: [
        {
          RequestType: 0,
          name: 'C-Get'
        },
        {
          RequestType: 1,
          name: 'C-Move'
        },
        {
          RequestType: 2,
          name: 'C-Find'
        }
      ],
      localQRInfos: [],
      qRSCUInfos: []
    }
  },
  methods: {
    // getLogs() {
    //   this.$api.get('dictionary/GetLogConfigurationEnum').then((res) => {
    //     this.LogsData = res.data
    //   })
    // },
    SetQrBaseConfig() {
      this.baseData.isPrintSql == 1 ? true : false
      console.log(this.baseData);
      this.$api.post('/dictionary/updateQrBaseConfig', {
        ...this.baseData,
        isPrintSql: this.baseData.isPrintSql == 1 ? true : false
      }).then((res) => {
        if (res.statusCode == '200') {
          this.$Message.success('修改成功')
          this.getQrBaseConfig()
        }
      })
    },
    cancelEdit() {
      // console.log(this.oldBaseData);
      // this.baseData = this.oldBaseData
      // this.baseData.isPrintSql = this.baseData.isPrintSql ? 1 : 0
      this.getQrBaseConfig()
    },
    getQrBaseConfig() {
      this.$api.get('dictionary/getQrBaseConfig').then((res) => {
        //console.log('-------------------',res);
        this.baseData = res.data
        this.baseData.isPrintSql = this.baseData.isPrintSql ? 1 : 0
        this.oldBaseData = JSON.parse(JSON.stringify(this.baseData))
        console.log(this.baseData);
      })
    },




    changeSwitch(val) {
      this.isOPen = val
      this.$api.post('dictionary/updateServiceStatus', {
        serviceSign: this.serviceSign,
        serviceStatus: this.isOpen
      }).then((res) => {
        //这块服务被封装了
        if (!res) {
          this.isOpen = !this.isOpen
          this.Status= this.result.serviceStatus
          // setTimeout(() => {
          //   this.getServiceInfo()
          // }, 10000);
          this.timer=setInterval(() => {
            this.getServiceInfo()
          }, 10000)
        } else {
          this.getServiceInfo()
        }

        // if(res.data.msg=='服务正在启动中不允许操作'){
        // }
      })
    },
    getlocalQRInfos() {
      try {
        this.$api.get(`dictionary/qrConfig`, { serviceSign: 'ProcessCenterQR' }).then((res) => {
          this.localQRInfos = res.data ? (JSON.parse(res.data.serviceParams)).localQRInfos : []


        });
      } catch (err) {
        console.log(error);
        this.$Message.warning('')
      }
    },
    getQRSCUInfos() {
      this.$api.get(`dictionary/qrConfig`, { serviceSign: 'ProcessCenterQR' }).then((res) => {
        this.qRSCUInfos = res.data ? (JSON.parse(res.data.serviceParams)).qRSCUInfos : []
      });
      console.log(this.qRSCUInfos);
    },
    getAllData() {
      this.getlocalQRInfos()
      this.getQRSCUInfos()
    },
    getServiceInfo() {
      this.$api.get(`dictionary/getServiceInfo`, { serviceSign: 'ProcessCenterQR' }).then((res) => {
        console.log(res);
        this.serviceSign = res.data.serviceSign
        this.result = res.data
        if(this.Status!== res.data.serviceStatus){
          clearInterval(this.timer)
        }
        this.isOpen = res.data.serviceStatus === 10
      })
    },
    close() {
      this.showLog = false
    },
    clear(mode) {
      this.btnName = this.btnAEname = '新增'
      if (mode == 'listen') {
        this.paramsListen.LocalPort = ''
        this.paramsListen.LocalAE = ''
        this.paramsListen.LoacalIP = ''
        this.getlocalQRInfos()
      } else {
        this.paramsAE.IP = ''
        this.paramsAE.AE = ''
        this.paramsAE.RequestType = ''
        this.paramsAE.RemoteIP = ''
        this.paramsAE.RemotePort = ''
        this.paramsAE.RemoteAe = ''
        this.getQRSCUInfos()
      }
    },
    delete(mode, data) {
      this.$Modal.confirm({
        title: "确认要删除么？",
        mask: false,
        onOk: () => {
          if (mode == 'listen') {
            this.localQRInfos.splice(data._index, 1)
          } else {
            this.qRSCUInfos.splice(data._index, 1)
          }
          this.saveData(mode)
        }
      })
    },
    addOrEidt(mode, type, data) {
      if (mode == 'listen') {
        if (type == 'edit') {
          this.paramsListen = Object.assign({}, data)
          this.btnName = '保存'
        }
      } else {
        if (type == 'edit') {
          this.paramsAE = Object.assign({}, data)
          this.btnAEname = '保存'
        }
      }
      if (type == 'save') {
        if (mode == 'listen') {
          if (this.btnName == '保存') {//编辑状态
            this.localQRInfos.splice(this.paramsListen._index, 1)
          }
          this.localQRInfos.push(this.paramsListen)
        } else {
          if (this.btnAEname == '保存') {//编辑状态
            this.qRSCUInfos.splice(this.paramsAE._index, 1)
          }
          this.qRSCUInfos.push(this.paramsAE)
        }
        this.saveData(mode)
      }
    },
    savelocalQRInfos(mode) {
      this.$api.post(`dictionary/AddOREditQRlocalQRInfos`, { localQRInfos: this.localQRInfos }).then((res) => {
         if (res.statusCode == 200) {
          this.$Message.success(res.msg)
        }
        this.clear(mode)
      });
    },
    saveQRSCUInfos(mode) {
      this.$api.post(`dictionary/AddOrEditQRqrSCUInfos`, { qRSCUInfos: this.qRSCUInfos }).then((res) => {
        if(res.statusCode==200){
          this.$Message.success(res.msg)
        }
        this.clear(mode)
      });
    },
    saveData(mode) {
      if (mode == 'listen') {
        this.savelocalQRInfos(mode)
      } else {
        this.saveQRSCUInfos(mode)
      }
    }
  },
  created() {
    this.LogsData = this.$parent.LogsData
  },
  mounted() {

    this.getQrBaseConfig()
    this.getServiceInfo()
    this.getAllData()
  }
}
</script>
<style scoped lang="scss">
.scpPage {
  color: #333;

  .operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .status {
      width: 74px;
      height: 74px;
      background: rgba(0, 168, 112, 0.1);
      border-radius: 50%;
      font-size: 18px;
      font-weight: 400;
      color: #00a870;
      line-height: 74px;
      text-align: center;
    }
  }

  .line {
    width: 4px;
    height: 18px;
    background: #338BFF;
    margin: 0 8px 0 0;
  }

  .first {
    display: flex;
    justify-content: space-between;
    margin: 16px 0 12px 0;
    height: 32px;
    line-height: 32px;

    .tit {
      display: flex;
      align-items: center;
      font-size: 16px;
    }

    .log {
      width: 82px;
      text-align: center;
      background: #F2F7FF;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: #338BFF;
      cursor: pointer;
      margin: 0 8px 0 0;
    }
  }

  .des {
    display: flex;
    border: 1px solid #E5E5E5;
    padding: 18px 12px;

    .serDes {
      margin: 0 24px 0 0;
    }

    .secondTit {
      color: #666666;
    }
  }

  .listenList {
    display: flex;

    .tit {
      display: flex;
    }

    .left {
      width: 314px;
      margin: 16px 0px 0 20px;

      .contain {
        border: 1px solid #DCDCDC;
        padding: 12px;
        margin: 12px 0 0 0;
      }

      .btnGroup {
        display: flex;
        justify-content: flex-end;
        margin: 12px 0 16px 20px;

        .cancel {
          margin: 0 12px 0 0;
        }
      }
    }

    .right {
      width: calc(100% - 330px);
      margin: 16px 0 0 0;

      .tit {
        margin: 0 0 16px 0;
      }

      .tip {
        font-size: 10px;
        font-weight: 400;
        color: #FF4D4F;
      }
    }
  }
}</style>
<style>.scpPage .ivu-form-item {
  margin-bottom: 12px;
}</style>